import { RESET_REDUCERS } from '../auth/types';
import { protocolsColumns } from '../../settings/tableColumns';
import { STUDENTS_COPY_FINAL_MARKS_START as STRONA_PRZEDMIOTU_STUDENTS_COPY_FINAL_MARKS_START } from '../dynamicTabs/stronaPrzedmiotu/types';
import { appConfigActionTypes } from '.';
import { ActionTypes } from './interfaces';

import { getDefaultLanguage } from '../../settings/i18n/i18n';

const initState: AppConfig.State = {
  navPanel: {
    opened: false,
  },
  protocolModal: {
    opened: false,
    loading: false,
    protocols: [],
    error: false,
    columns: protocolsColumns,
    semestrAkademicki: null,
    rokAkademicki: null,
  },
  changeLogPanel: {
    opened: false,
    data: [],
    loading: false,
    error: false,
  },
  pairEffectsModal: {
    opened: false,
    data: null,
    loading: false,
    loadingEffects: false,
    error: false,
    studyPrograms: [],
    selectedStudyProgram: null,
    selectedLang: null,
    selectedVersion: null,
    selectedEffects: [],
    availableEffects: [],
    tabId: null,
    selectProgramOpenState: false,
  },
  realizatorzyListModal: {
    opened: false,
    realizatorzyList: [],
    loading: false,
    error: false,
    selected: [],
  },
  copyCardsDataModal: {
    opened: false,
    cardsList: [],
    loading: false,
    error: false,
    selected: null,
    searchPhrase: '',
    przedmiotId: null,
    tabId: null,
  },
  copyFinalMarksModal: {
    studentsWithManuallySignedFinalMark: 0,
    studentsWithoutOcenaWyliczona: 0,
    studentsWithMarksByAnotherCounter: 0,
    selected: 0,
    opened: false,
    data: null,
    studentData: [],
    loading: false,
    error: {
      isError: false,
    },
    tabId: null,
  },
  maintenanceMode: [],
  currentLanguage: getDefaultLanguage(),
  isCheckingApiStatus: false,
  notificationListAdmin: [],
};

export default function appConfigReducer(state: AppConfig.State = initState, action: ActionTypes): AppConfig.State {
  switch (action.type) {
    // Panel nawigacyjny
    case appConfigActionTypes.NAV_PANEL_CLOSE:
      return {
        ...state,
        navPanel: {
          ...state.navPanel,
          opened: false,
        },
      };
    case appConfigActionTypes.NAV_PANEL_TOGGLE:
      return {
        ...state,
        navPanel: {
          ...state.navPanel,
          opened: !state.navPanel.opened,
        },
      };
    // język aplikacji
    case appConfigActionTypes.LANGUAGE_SET:
      return {
        ...state,
        currentLanguage: action.payload.language,
      };
    // Modal generowania protokołów
    case appConfigActionTypes.PROTOCOL_MODAL_OPEN: {
      const [rokAkademicki, semestrAkademicki] = action.payload.poraRoku.split('-');
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          opened: true,
          semestrAkademicki,
          rokAkademicki,
        },
      };
    }
    case appConfigActionTypes.PROTOCOL_MODAL_CLOSE:
      return {
        ...state,
        protocolModal: {
          ...initState.protocolModal,
        },
      };
    case appConfigActionTypes.PROTOCOL_GENERATE_SINGLE_START:
    case appConfigActionTypes.PROTOCOL_GENERATE_GROUP_START:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          loading: true,
        },
      };
    case appConfigActionTypes.PROTOCOL_GENERATE_SINGLE_FAIL:
    case appConfigActionTypes.PROTOCOL_GENERATE_GROUP_FAIL:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          loading: false,
          error: true,
        },
      };
    case appConfigActionTypes.PROTOCOL_GET_STATUS_SUCCESS:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          loading: false,
          protocols: action.payload.map(item => ({
            data: {
              ...item,
              key: item.protId,
            },
            loading: false,
            printInProcess: false,
            downloadInProcess: false,
            error: false,
            pdfFile: null,
            pdfGenerateStatus: {
              status: item.czyWygenerowany !== 3 && item.czyWygenerowany !== 4,
              errors: {
                unknown: item.czyWygenerowany === 3,
                noSignMarks: item.czyWygenerowany === 4,
              },
            },
          })),
        },
      };
    case appConfigActionTypes.PROTOCOL_GET_STATUS_FAIL:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          loading: false,
          error: true,
        },
      };
    case appConfigActionTypes.PROTOCOL_PDF_GET_SUCCESS:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          protocols: state.protocolModal.protocols.map(item =>
            item.data.protId === action.payload.protId
              ? {
                  ...item,
                  pdfFile: action.payload.data,
                }
              : { ...item },
          ),
        },
      };
    case appConfigActionTypes.PROTOCOL_PDF_GET_FAIL:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          protocols: state.protocolModal.protocols.map(item =>
            item.data.protId === action.payload.protId
              ? {
                  ...item,

                  loading: false,
                  error: true,
                }
              : { ...item },
          ),
        },
      };
    case appConfigActionTypes.PROTOCOL_PDF_PRINT_OUT_START:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          loading: false,
          protocols: state.protocolModal.protocols.map(item =>
            item.data.protId === action.payload.protId
              ? {
                  ...item,
                  printInProcess: true,
                }
              : { ...item },
          ),
        },
      };
    case appConfigActionTypes.PROTOCOL_PDF_PRINT_OUT_SUCCESS:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          loading: false,
          protocols: state.protocolModal.protocols.map(item =>
            item.data.protId === action.payload.protId
              ? {
                  ...item,
                  printInProcess: false,
                  pdfFile: null,
                }
              : { ...item },
          ),
        },
      };
    case appConfigActionTypes.PROTOCOL_PDF_DOWNLOAD_START:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          loading: false,
          protocols: state.protocolModal.protocols.map(item =>
            item.data.protId === action.payload.protId
              ? {
                  ...item,
                  downloadInProcess: true,
                }
              : { ...item },
          ),
        },
      };
    case appConfigActionTypes.PROTOCOL_PDF_DOWNLOAD_SUCCESS:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          loading: false,
          protocols: state.protocolModal.protocols.map(item =>
            item.data.protId === action.payload.protId
              ? {
                  ...item,
                  downloadInProcess: false,
                  pdfFile: null,
                }
              : { ...item },
          ),
        },
      };
    case appConfigActionTypes.PROTOCOL_PDF_DOWNLOAD_FAIL:
      return {
        ...state,
        protocolModal: {
          ...state.protocolModal,
          loading: false,
          protocols: state.protocolModal.protocols.map(item =>
            item.data.protId === action.payload.protId
              ? {
                  ...item,
                  downloadInProcess: true,
                }
              : { ...item },
          ),
        },
      };
    // historia ocen
    case appConfigActionTypes.CHANGE_LOG_MODAL_OPEN:
      return {
        ...state,
        changeLogPanel: {
          ...state.changeLogPanel,
          opened: true,
          loading: true,
        },
      };
    case appConfigActionTypes.CHANGE_LOG_MODAL_CLOSE:
      return {
        ...state,
        changeLogPanel: {
          ...initState.changeLogPanel,
        },
      };
    case appConfigActionTypes.CHANGE_LOG_DATA_GET_SUCCESS:
      return {
        ...state,
        changeLogPanel: {
          ...state.changeLogPanel,
          data: action.payload.data,
          loading: false,
        },
      };
    case appConfigActionTypes.CHANGE_LOG_DATA_GET_FAIL:
      return {
        ...state,
        changeLogPanel: {
          ...state.changeLogPanel,
          loading: false,
          error: true,
        },
      };
    // Parowanie efektów
    case appConfigActionTypes.PAIR_EFFECTS_MODAL_OPEN:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          opened: true,
          loading: true,
          data: action.payload.data,
          tabId: action.payload.tabId,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_MODAL_CLOSE:
      return {
        ...state,
        pairEffectsModal: {
          ...initState.pairEffectsModal,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_GET_STUDY_PROGRAMS_SUCCESS:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          studyPrograms: action.payload.data,
          loading: false,
          selectProgramOpenState: true,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_GET_STUDY_PROGRAMS_FAIL:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          loading: false,
          error: true,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_SELECT_STUDY_PROGRAM:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          selectedStudyProgram: action.payload.program,
          selectProgramOpenState: false,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_SELECT_CARD_LANGUAGE:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          selectedLang: action.payload.lang,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_SELECT_CARD_VERSION:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          selectedVersion: action.payload.version,
        },
      };
    case appConfigActionTypes.CHANGE_SELECT_PROGRAM_OPEN:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          selectProgramOpenState: action.payload.opened,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_GET_STUDY_PROGRAMS:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          selectedStudyProgram: initState.pairEffectsModal.selectedStudyProgram,
          studyPrograms: initState.pairEffectsModal.studyPrograms,
          selectedEffects: initState.pairEffectsModal.selectedEffects,
          availableEffects: initState.pairEffectsModal.availableEffects,
          loading: true,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_GET_LEARNING_EFFECTS_START:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          loadingEffects: true,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_GET_LEARNING_EFFECTS_SUCCESS:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          availableEffects: action.payload.data.map((item: AppConfig.LearningEffect) => ({ ...item, key: item.efektKierunkuId })),

          loadingEffects: false,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_GET_LEARNING_EFFECTS_FAIL:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          loadingEffects: false,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_SUCCESS:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          selectedEffects: action.payload.data,
        },
      };
    case appConfigActionTypes.PAIR_EFFECTS_SELECT_LEARNING_EFFECTS:
      return {
        ...state,
        pairEffectsModal: {
          ...state.pairEffectsModal,
          selectedEffects: action.payload.data,
        },
      };
    case appConfigActionTypes.REALIZATORZY_MODAL_OPEN:
      return {
        ...state,
        realizatorzyListModal: {
          ...state.realizatorzyListModal,
          opened: true,
          loading: !state.realizatorzyListModal.realizatorzyList.length,
        },
      };
    case appConfigActionTypes.REALIZATORZY_MODAL_CLOSE:
      return {
        ...state,
        realizatorzyListModal: {
          ...state.realizatorzyListModal,
          opened: false,
          selected: [],
        },
      };
    case appConfigActionTypes.REALIZATORZY_GET_LIST_SUCCESS:
      return {
        ...state,
        realizatorzyListModal: {
          ...state.realizatorzyListModal,
          loading: false,
          realizatorzyList: action.payload.data,
        },
      };
    case appConfigActionTypes.REALIZATORZY_GET_LIST_FAIL:
      return {
        ...state,
        realizatorzyListModal: {
          ...state.realizatorzyListModal,
          loading: false,
          error: true,
        },
      };
    case appConfigActionTypes.REALIZATORZY_SELECT:
      return {
        ...state,
        realizatorzyListModal: {
          ...state.realizatorzyListModal,
          selected: action.payload.selectedData,
        },
      };
    // kopiowanie karty przedmiotu
    case appConfigActionTypes.COPY_SUBJECT_CARD_MODAL_OPEN:
      return {
        ...state,
        copyCardsDataModal: {
          ...state.copyCardsDataModal,
          opened: true,
          przedmiotId: action.payload.przedmiotId,
          tabId: action.payload.tabId,
        },
      };
    case appConfigActionTypes.COPY_SUBJECT_CARD_MODAL_CLOSE:
      return {
        ...state,
        copyCardsDataModal: {
          ...initState.copyCardsDataModal,
        },
      };
    case appConfigActionTypes.COPY_SUBJECT_CARD_GET_LIST_START:
      return {
        ...state,
        copyCardsDataModal: {
          ...state.copyCardsDataModal,
          loading: true,
        },
      };
    case appConfigActionTypes.COPY_SUBJECT_CARD_GET_LIST_SUCCESS:
      return {
        ...state,
        copyCardsDataModal: {
          ...state.copyCardsDataModal,
          loading: false,
          error: false,
          cardsList: action.payload.data,
        },
      };
    case appConfigActionTypes.COPY_SUBJECT_CARD_GET_LIST_FAIL:
      return {
        ...state,
        copyCardsDataModal: {
          ...state.copyCardsDataModal,
          loading: false,
          error: true,
        },
      };
    case appConfigActionTypes.COPY_SUBJECT_CARD_START:
      return {
        ...state,
        copyCardsDataModal: {
          ...state.copyCardsDataModal,
          loading: true,
        },
      };
    case appConfigActionTypes.COPY_SUBJECT_CARD_SUCCESS:
      return {
        ...state,
        copyCardsDataModal: {
          ...state.copyCardsDataModal,
          loading: false,
          error: false,
        },
      };
    case appConfigActionTypes.COPY_SUBJECT_CARD_FAIL:
      return {
        ...state,
        copyCardsDataModal: {
          ...state.copyCardsDataModal,
          loading: false,
          error: true,
        },
      };
    case appConfigActionTypes.COPY_SUBJECT_CARD_SELECT:
      return {
        ...state,
        copyCardsDataModal: {
          ...state.copyCardsDataModal,
          selected: action.payload.id,
        },
      };
    case appConfigActionTypes.COPY_SUBJECT_CARD_SET_SEARCH:
      return {
        ...state,
        copyCardsDataModal: {
          ...state.copyCardsDataModal,
          searchPhrase: action.payload.searchPhrase,
        },
      };
    case appConfigActionTypes.COPY_FINAL_MARKS_MODAL_OPEN:
      return {
        ...state,
        copyFinalMarksModal: {
          ...state.copyFinalMarksModal,
          error: {
            isError: false,
          },
          opened: true,
        },
      };
    case appConfigActionTypes.COPY_FINAL_MARKS_MODAL_CLOSE:
      return {
        ...state,
        copyFinalMarksModal: {
          ...state.copyFinalMarksModal,
          opened: false,
        },
      };
    case STRONA_PRZEDMIOTU_STUDENTS_COPY_FINAL_MARKS_START:
      return {
        ...state,
        copyFinalMarksModal: {
          ...state.copyFinalMarksModal,
          loading: true,
        },
      };
    case appConfigActionTypes.COPY_FINAL_MARKS_MODAL_SET_STUDENTS_IN_STATE:
      return {
        ...state,
        copyFinalMarksModal: {
          ...state.copyFinalMarksModal,
          studentData: action.payload.data.map((student: SingleObjectDataStructure) => ({ ...student, key: student.studentId })),
          loading: false,
          selected: action.payload.selected ? action.payload.selected : initState.copyFinalMarksModal.selected,
          studentsWithoutOcenaWyliczona: action.payload.studentsWithoutOcenaWyliczona
            ? action.payload.studentsWithoutOcenaWyliczona
            : initState.copyFinalMarksModal.studentsWithoutOcenaWyliczona,
          studentsWithManuallySignedFinalMark: action.payload.studentsWithManuallySignedFinalMark
            ? action.payload.studentsWithManuallySignedFinalMark
            : initState.copyFinalMarksModal.studentsWithManuallySignedFinalMark,
          studentsWithMarksByAnotherCounter:
            action.payload.studentsWithMarksByAnotherCounter ?? initState.copyFinalMarksModal.studentsWithManuallySignedFinalMark,
        },
      };
    case appConfigActionTypes.COPY_FINAL_MARKS_MODAL_SET_PRZEDMIOT_IN_STATE:
      return {
        ...state,
        copyFinalMarksModal: {
          ...state.copyFinalMarksModal,
          data: action.payload.data,
          tabId: action.payload.tabId,
        },
      };
    case appConfigActionTypes.COPY_FINAL_MARKS_FAIL:
      return {
        ...state,
        copyFinalMarksModal: {
          ...state.copyFinalMarksModal,
          error: {
            isError: true,
            hash: action.payload.hash,
          },
          loading: false,
        },
      };
    case appConfigActionTypes.MAINTENANCE_MODE_SET:
      return {
        ...state,
        maintenanceMode: action.payload.maintenanceList,
      };
    case appConfigActionTypes.CHECK_API_STATUS:
      return {
        ...state,
        isCheckingApiStatus: true,
      };
    case appConfigActionTypes.CHECK_API_STATUS_FINISH:
      return {
        ...state,
        isCheckingApiStatus: false,
      };

    case appConfigActionTypes.GET_NOTIFICATION_LIST_ADMIN_FINISH:
      return {
        ...state,
        notificationListAdmin: action.payload.notificationList,
      };

    case RESET_REDUCERS:
      // reset danych stora
      return {
        ...initState,
      };
    default:
      return state;
  }
}
